import { atom } from 'recoil'

export type CountCollectionEntry = {
  entityName: string
  viewName: string
  count: number
}

export class CountCollection {
  private readonly collection: Record<string, number>

  constructor(collection?: Record<string, number>) {
    this.collection = {}
    if (collection) {
      this.collection = { ...collection }
    }
  }

  public upsertItem(entity: string, view: string, count: number) {
    const key = this.getKey(entity, view)
    this.collection[key] = count
  }

  public deleteItem(entity: string, view: string) {
    const key = this.getKey(entity, view)
    delete this.collection[key]
  }

  public getItem(entity: string, view: string) {
    const key = this.getKey(entity, view)
    return this.collection[key]
  }

  public clone() {
    const newCollection = new CountCollection(this.collection)
    return newCollection
  }

  private getKey(entity: string, view: string) {
    return `${entity}.${view}`
  }
}

export const $countCollection = atom({
  key: 'CountCollection',
  default: new CountCollection(),
})
